module.exports = __webpack_public_path__ + "img/home.ba24cb2d.jpg";